var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',_vm._g(_vm._b({attrs:{"modal-append-to-body":false,"width":"auto","destroy-on-close":_vm.destroyOnClose}},'el-dialog',_vm.$attrs,false),_vm.$listeners),[_c('div',{staticClass:"box"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }